// Progress Service - Handles progress API calls
import api from './api';

export interface ProgressEntry {
  experimentId: number;
  experimentNumber: number;
  partId: number;
  stepId: number;
  completed: boolean;
  completedAt: string | null;
  data: unknown;
}

export interface CourseProgressResponse {
  success: boolean;
  courseId: string;
  progress: ProgressEntry[];
}

export interface SyncProgressEntry {
  experimentNumber: number;
  partId: number;
  stepId: number;
  completed: boolean;
  data?: unknown;
}

class ProgressService {
  async getCourseProgress(courseId: string): Promise<ProgressEntry[]> {
    const result = await api.get<CourseProgressResponse>(`/progress/${courseId}`);

    if (result.success && result.data?.progress) {
      return result.data.progress;
    }

    return [];
  }

  async updateProgress(
    courseId: string,
    experimentNumber: number,
    partId: number,
    stepId: number,
    completed: boolean,
    data?: unknown
  ): Promise<boolean> {
    const result = await api.put(
      `/progress/${courseId}/${experimentNumber}/${partId}/${stepId}`,
      { completed, data }
    );

    return result.success;
  }

  async syncProgress(courseId: string, progress: SyncProgressEntry[]): Promise<number> {
    const result = await api.post<{ success: boolean; synced: number }>(
      `/progress/${courseId}/sync`,
      { progress }
    );

    if (result.success && result.data) {
      return result.data.synced;
    }

    return 0;
  }

  async resetExperimentProgress(courseId: string, experimentNumber: number): Promise<boolean> {
    const result = await api.delete(`/progress/${courseId}/${experimentNumber}`);
    return result.success;
  }
}

export const progressService = new ProgressService();
export default progressService;
